import {
  EmailPayload
} from '../types'
import { fetchEnvironmentVar } from '../utils/miscUtils'

export const sendEmail = async (requestData: EmailPayload): Promise<any> => {
  const apiUrl = fetchEnvironmentVar('REACT_APP_API_URL')
  const response = await fetch(`${apiUrl}/api/v1/send_email`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(requestData)
  })

  if (!response.ok) {
    const errorData = await response.json()
    throw new Error(errorData.message || 'Failed to send email. Please try again later.')
  }

  return await response.json()
}
